<script setup lang="ts">
import { DiscountBadge } from "~/components/clarity-ui/DiscountBadge";
import { useFormattedPercent } from "~/composables/useFormattedPercent";

export interface DiscountRateLabelProps {
  discountRate: number;
}

const { discountRate } = defineProps<DiscountRateLabelProps>();

// We need to use the Composable to format the value as the <FormattedPercent> component will create
// a VNode which is then ignored by calculating the length of the slot content.
const formattedValue = computed(() => {
  const { formattedValue } = useFormattedPercent(discountRate, { precision: 0 });
  return formattedValue;
});
</script>

<template>
  <div>
    <DiscountBadge>-{{ formattedValue }}</DiscountBadge>
  </div>
</template>
